import { t } from "i18next";
import { date, object } from "yup";

import { addressSchema } from "../../../../components/AddressInput";

export function getSchema(isCurrentAddress: boolean) {
  return addressSchema.concat(
    object().shape({
      start_date: date().required().label(t("Start date")),
      end_date: date().when(["start_date"], ([start_date], schema) => {
        if (isCurrentAddress) {
          return schema.notRequired();
        }

        if (start_date) {
          return schema
            .required()
            .label(t("End date"))
            .min(start_date, t("End date must be after start date"));
        }

        return schema.required().label(t("End date"));
      }),
    })
  );
}
